export const salvarFiltros = (page, filtros) => {
  return window.mainoDb().then(db => {
    return db.putData(`preferencias_filtros_${page}`, JSON.stringify(filtros));
  });
};

export const recuperarFiltros = (page) => {
  return window.mainoDb().then(db => {
    return db.getData(`preferencias_filtros_${page}`).then(result => {
      try {
        return result?.data ? JSON.parse(result.data) : [];
      } catch (e) {
        console.warn('Erro ao fazer parse dos filtros:', e);
        return [];
      }
    });
  });
};

export const removerFiltros = (page) => {
  return window.mainoDb().then(db => {
    return db.deleteData(`preferencias_filtros_${page}`);
  });
};

export const removeFiltro = (page, filtro) => {
  return window.mainoDb().then(db => {
    return db.getData(`preferencias_filtros_${page}`).then(result => {
      let filtros = [];
      try {
        filtros = result?.data ? JSON.parse(result.data) : [];
      } catch (e) {
        console.warn('Erro ao fazer parse dos filtros:', e);
      }
      
      const filtrosAtualizados = filtros.filter(f => f.filtro !== filtro);
      return db.putData(`preferencias_filtros_${page}`, JSON.stringify(filtrosAtualizados));
    });
  });
};
